// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header">
            <h1>Network Connection Lost</h1>
        </div>
        <div class="hoa-dialog__main">
            <p class="u-textCenter">Network connection was lost. Please reconnect before retrying.</p>
        </div>
        <div class="hoa-dialog__footer"
             ifOverFlowXClass="hoa-dialog__footer--overflowX">
            <button class="Button Button--blue Button--minWidth130" (click)="closeDialog(0)">OK</button>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;